
$(function() {
    /*フィルターの文字を絞り込みへ*/    
    /*var price = $(".ProductItem__Price").html();
    price = price.split("から").join('〜');
    if(price) {
        $(".ProductItem__PriceList").html(price);
    };*/

    // 商品詳細情報移動
	var listbox = $('.PageHeader .SectionHeader__Description .list-box');
	$('.PageHeader .SectionHeader__Description').after(listbox);
});